export default __webpack_public_path__ + "static/media/HG-full-logo.fb05d926.svg";